<template>
  <div>
      <div class="flex justify-center text-dark" :class="classes" @click="handleClick">
    <feather-icon :icon="icon" svgClasses="h-4 w-4" class="mr-1  font-bold" />
    <p class="font-bold mr-1" :class="{'text-large': small, 'text-xl': !small}">{{title}} <span :class="{'opacity-0': !plus}">
        <span>+</span>
      </span> </p>
      <slot></slot>
  </div>
   <div v-if="hint" class="text-xs text-dark flex justify-center">
    <label>{{hint}}</label>
  </div>
</div>

</template>
<script>


export default {
  components: {
  },
  props: ['icon', 'title', 'small', 'plus', 'hint'],
  data () {
    return {
    }
  },
  watch: {
  },
  methods: {
    handleClick () {
      if (this.plus) {
        this.$emit('plusClicked')
      }
    }
  },
  computed: {
    classes () {
      if (this.plus) {
        return this.actionElementCss
      } else {
        return ""
      }
    }

  },
}
</script>

<style scoped>
</style>
